export default __webpack_public_path__ + "static/media/desk-ipad.95dd87d3.jpg";